import React from "react";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardImg,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useForm, SubmitHandler } from 'react-hook-form';
import classnames from "classnames";
import RegisterForm from "../../modules/login/RegisterForm.tsx";
// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footer/Footer.js";
import Toast from '../../utils/Toast.ts';

const GenderEnum = {
  female: "female",
  male: "male",
  other: "other",
}

interface IFormInput {
  firstName: string,
  gender: GenderEnum
}


export default function MemberPage() {

  const [squares1to6, setSquares1to6] = React.useState("");
  const [squares7and8, setSquares7and8] = React.useState("");
  const [done, setDone] = React.useState(false);
  const startData: any = {};
  function handleDone() {
    setDone(true);
  }

  

  React.useEffect(() => {
    document.body.classList.toggle("register-page");
    document.documentElement.addEventListener("mousemove", followCursor);
    // Specify how to clean up after this effect:
    return function cleanup() {
      document.body.classList.toggle("register-page");
      document.documentElement.removeEventListener("mousemove", followCursor);
    };
  }, []);
  const followCursor = (event) => {
    let posX = event.clientX - window.innerWidth / 2;
    let posY = event.clientY - window.innerWidth / 6;
    setSquares1to6(
      "perspective(500px) rotateY(" +
        posX * 0.05 +
        "deg) rotateX(" +
        posY * -0.05 +
        "deg)"
    );
    setSquares7and8(
      "perspective(500px) rotateY(" +
        posX * 0.02 +
        "deg) rotateX(" +
        posY * -0.02 +
        "deg)"
    );
  };
  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <div className="page-header">
          <div className="page-header-image" />
          <div className="content">
            <Container>
              <Row>
                <Col className="offset-lg-0 offset-md-3" lg="7" md="6">
                  <div
                    className="square square-7"
                    id="square7"
                    style={{ transform: squares7and8 }}
                  />
                  <div
                    className="square square-8"
                    id="square8"
                    style={{ transform: squares7and8 }}
                  />
                  <Card className="card-register">
                    <CardHeader>
                    <CardImg
                        alt="..."
                        src={require("assets/img/square-purple-1.png")}
                      />
                      <CardTitle tag="h4">Membro</CardTitle>                      
                    </CardHeader>
                    <CardBody>
                      
                    Para se tornar membro é necessário instalar o aplicativo da igreja em seu celular.
                    Segue os links para Android e IPhone.     
                    <a
                      href="https://play.google.com/store/apps/details?id=br.com.sistemaprover.conectados"
                      
                    >
                      <img
                                  alt="..."
                                  className="img-center img-fluid"
                                  src={"/android.png"}
                                  width={210}
                                />      
                    </a>
                    <p>O app para IPhone ainda está sendo homologado.</p>
                    <img
                                alt="..."
                                className="img-center img-fluid"
                                src={"/appstore.png"}
                                width={200}
                              />                                                 
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              
              <div
                className="square square-1"
                id="square1"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-2"
                id="square2"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-3"
                id="square3"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-4"
                id="square4"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-5"
                id="square5"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-6"
                id="square6"
                style={{ transform: squares1to6 }}
              />
            </Container>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
